<template>
  <div v-if="errors.length !== 0" class="errors">
    <div v-for="error in errors" v-bind:key="error" class="text-center">
      <h2> {{ $t(`error.${error}`) }}</h2>
    </div>
  </div>

  <div v-else class="offline-formEdit">
    <b-row v-if="isLoading" class="loader-section">
      <frontoffice-loader />
    </b-row>

    <div v-else>
      <div class="header">
        <page-title>
          <b-row class="header-row justify-content-center">
            <div v-if="!anonymous" cols="12" md="7" class="col-12 col-md-7 p-0">
              {{ $t(pageTitle) }}
            </div>

            <div v-else class="public-title col-xl-8 col-lg-10">
              <b-row>
                <span class="col-12 col-md-9">{{ $t(pageTitle) }}</span>
                <div class="col-12 col-md-3">
                  <back-button
                    name="public_booking_show"
                    :token="token"
                    class="text-center orange-white btn"
                  >
                    {{ $t("offline.show_booking") }}
                  </back-button>
                </div>
              </b-row>
            </div>

            <b-col v-if="!anonymous" cols="12" md="5" class="back-link">
              <b-row class="btn-row">
                <div class="col-6 col-md-12 col-lg-6 back-link-p0">
                  <back-button
                    name="bookings"
                    class="text-md-center orange-white btn"
                  >
                    {{ $t("_back_list") }}
                  </back-button>
                </div>

                <div class="col-6 col-md-12 col-lg-6 back-link-p0">
                  <back-button
                    name="home_booking_show"
                    :id="bookingId"
                    class="text-center orange-white btn"
                  >
                    {{ $t("offline.show_booking") }}
                  </back-button>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </page-title>
      </div>

      <div class="reminder-row row justify-content-center">
        <div class="col-12 col-md-8 col-xl-6 reminder-content-row">
          <part :title="$t('offline.reminder')">
            <div class="reminder-date-inner">
              <p class="title reminder-title">{{ $t("_journey_dates") }} :</p>
              <p class="reminder-date-content">
                <span class="reminder-date-content-period from">
                  {{ $t("_period.from") }}
                  {{ formatDate(booking.arrival_date) }}
                </span>
                <span class="reminder-date-content-period to">
                  {{ $t("_period.to") }}
                  {{ formatDate(booking.departure_date) }}
                </span>
              </p>
            </div>

            <div class="reminder-dest-inner">
              <p class="title reminder-title">{{ destination.label }} :</p>

              <p class="reminder-dest-content">
                {{ destination.value }}
              </p>
            </div>
          </part>
        </div>
      </div>

      <b-row><hr /></b-row>

      <b-row class="justify-content-center">
        <div class="col-12 col-lg-10 col-xl-8 message-row">
          <part :title="$t('offline.your_message')">
            <textarea-input
              name="comment"
              :placeholder="$t('offline.placeholder')"
              v-model="comment"
              class="message-area"
            />
          </part>

          <b-row>
            <part class="col-12 submit text-center">
              <input
                type="button"
                :value="$t('_send')"
                name="submit-edit"
                class="orange-white form-button btn"
                @click="onSubmit"
              />
            </part>
          </b-row>
        </div>
      </b-row>
    </div>

    <b-row v-if="displayErrors" class="errors alert-danger">
      {{ $t("error.10") }}
    </b-row>

    <div v-if="!isLoading && !isEditable" class="notfound-back">
      <p class="error-message">
        {{ $t("booking.modify.impossible") }}
      </p>

      <p>
        <router-link class="orange-white btn" to="/">
          {{ $t("_home_page") }}
          <fa fa-class="home" />
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
import frontofficeLoader from "@/components/frontoffice/loader";
import fa from "@/components/global/icon/fontAwesome";
import textareaInput from "@/components/frontoffice/form/baseInput/textArea";
import CommonApi from "@/api/commonApi";
import submitButton from "@/components/frontoffice/form/baseInput/submit";
import FormSubmitter from "@/api/formSubmitter";
import pageTitle from "@/components/frontoffice/pageTitle";
import backButton from "@/components/frontoffice/button/back";
import formatter from "@/components/global/mixins/formatterMethods";
import part from "@/components/frontoffice/part";

export default {
  components: {
    frontofficeLoader,
    fa,
    textareaInput,
    submitButton,
    pageTitle,
    backButton,
    part,
  },

  mixins: [formatter],

  props: {
    anonymous: Boolean
  },

  data () {
    return {
      bookingId: parseInt(this.$route.params.id),
      isLoading: true,
      isEditable: false,
      booking: null,
      comment: "",
      commonApi: new CommonApi(),
      formSubmitter: this.$route.name === 'public_booking_edit' ? new FormSubmitter('public_offline_booking_edit') : new FormSubmitter("offline_booking_edit"),
      errors: [],
      displayErrors: false,
      token: this.$route.params.token,
    };
  },

  created() {
    if (this.anonymous) {
      this.commonApi.searchBookingPublic(this.token).then((response) => {
        if (response.data.success) {
          this.isEditable = true;

          if (this.isEditable) {
            this.booking = response.data.data.booking;

            this.isLoading = false;
          }
        } else {
          Object.entries(response.data.errors).forEach(error => {
            this.errors.push(this.$te(`error.${error[0]}`)
              ? error[0]
              : error[1]
            )
          })
        }
      })
    } else {
      this.commonApi.searchBooking(this.bookingId).then((response) => {
        this.isEditable = response.data.data.isEditable;

        if (response.data.data.isEditable) {
          this.booking = response.data.data.booking;

          this.isLoading = false;
        }
      });
    }
  },

  methods: {
    onSubmit() {
      let values = { comment: this.comment };
      this.formSubmitter
        .submitRequest(values, this.anonymous ? this.token : this.bookingId)
        .then((response) => {
          if (response['data']['success']) {
            this.dealSuccess(response['data']['data']['newId']);
          } else {
            this.dealFailure(response['data']['errors']);
          }
        });
    },

    dealSuccess(newId = null) {
      this.displayErrors = false;

      if (this.anonymous) {
        this.$router.push({
          name: "public_booking_show",
          params: {
            token: this.token,
            isEdit: true
          }
        })
      } else {
        this.$router.push({
          name: "booking_request_confirm",
          params: {
            id: newId !== null ? newId : this.bookingId,
          },
        });
      }
    },

    dealFailure(response) {
      this.displayErrors = true;
    },
  },

  computed: {
    pageTitle() {
      return this.duplicate
        ? "offline.duplicate.title"
        : this.booking.is_online
        ? "online.modify.title"
        : "offline.modify.title";
    },

    destination() {
      let ret = {
        label: this.$t("_destination"),
        value: null,
      };

      let formatHotelCity = (hotel) => {
        return {
          label: this.$t("_hotel"),
          value: (hotel.name += hotel.name
            .toLowerCase()
            .includes(hotel.city.toLowerCase())
            ? ""
            : ` (${hotel.city})`),
        };
      };

      if (this.booking.hotel) {
        ret = formatHotelCity(this.booking.hotel);
      } else if (this.booking.desired_hotel) {
        ret = formatHotelCity(this.booking.desired_hotel);
      } else if (this.booking.desired_location) {
        ret.value = `${this.booking.desired_location.city} - ${this.booking.desired_location.name}`;

        if (this.booking.desired_location.type)
          ret.value += ` (${this.$t(this.booking.desired_location.type)})`;
      } else if (this.booking.desired_city) {
        ret.value = this.booking.desired_city;
      }

      return ret;
    },
  },
};
</script>
<style scoped>
.public-title{
  margin-bottom: 40px;
  margin-top: 100px;
  border-bottom: 1px solid #E65011;
  padding-bottom: 1rem;
  font-family: "prata", serif;
}
</style>
